import * as firebaseConfig from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';

// replace this variable, with your own config variable
// from your firebase project
var config = {
  apiKey: "AIzaSyBr0AXEEqN6HFea_KtZDvsrETiIRwMA6BA",
  authDomain: "yoodu--food.firebaseapp.com",
  databaseURL: "https://yoodu--food.firebaseio.com",
  projectId: "yoodu--food",
  storageBucket: "yoodu--food.appspot.com",
  messagingSenderId: "964400280606",
  appId: "1:964400280606:web:61bb334148cc4d698b2a0f",
  measurementId: "G-VV467H6HQZ"
};
const firebase = firebaseConfig.initializeApp(config);
const firestore = firebaseConfig.firestore();
const firefunctions = firebaseConfig.functions();
const storage = firebase.storage();

firebase.firestore().settings({ timestampsInSnapshots: true });

export { firebase, firestore, firefunctions, storage };
